import React, { forwardRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import hideEye from "../../../assets/icons/icon hide.svg";
import ErrorMessage from "./ErrorMessage";
import InfoIconWithTooltip from "../../../components/InfoIconWithTooltip";

interface FormLoginInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "autoComplete"> {
    label: string;
    autoComplete?: boolean;
    error?: string;
    infoTooltip?: React.ReactNode;
}

const FormLoginInput = forwardRef<HTMLInputElement, FormLoginInputProps>(
    (
        {
            id,
            label,
            type = "text",
            autoComplete = false,
            error,
            infoTooltip,
            ...props
        },
        ref
    ) => {
        const [isPasswordVisible, setIsPasswordVisible] = useState(false);

        const togglePasswordVisibility = () => {
            setIsPasswordVisible(!isPasswordVisible);
        };

        return (
            <div className="flex flex-col">
                <div className="flex items-center justify-between">
                    <label htmlFor={id} className="font-semibold">
                        {label}
                    </label>
                    {infoTooltip && (
                        <InfoIconWithTooltip
                            tooltipContent={infoTooltip}
                            classes={{
                                root: "me-[17px]",
                                icon: "size-4",
                            }}
                        />
                    )}
                </div>
                <div className="relative mt-1">
                    <input
                        {...props}
                        ref={ref}
                        className={twMerge(
                            `search-bar`,
                            error &&
                                "border border-red-500 focus:border-red-500",
                            props.className
                        )}
                        id={id}
                        type={
                            type === "password" && !isPasswordVisible
                                ? "password"
                                : "text"
                        }
                        autoComplete={autoComplete ? "on" : "new-password"}
                    />
                    {type === "password" && (
                        <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                        >
                            {isPasswordVisible ? (
                                "Hide"
                            ) : (
                                <img
                                    src={hideEye}
                                    alt="Hide Eye"
                                    className="size-6"
                                />
                            )}
                        </button>
                    )}
                </div>
                <ErrorMessage message={error} />
            </div>
        );
    }
);

FormLoginInput.displayName = "FormLoginInput";

export default FormLoginInput;
